/**
 * ======================================================================
 * Store for assessment send/share, used by PRO and by PFI Chatbot.
 * ======================================================================
 */

import axios from 'axios/dist/axios';


const defaultState = {
    summaryDataNew: null,
    activeChapter: {
        // title : "Meine Empfehlung",
        // id: "1"
    },
    assessmentDateNew: null,
    assessmentTimeNew: null,
    mustShowRestrictedAccessPopup: false,
    assessmentVersion: null
};

// ======================================================================
// Initial State
// ======================================================================

const state = {
    summaryDataNew:                 defaultState.summaryDataNew,
    activeChapter:                  defaultState.activeChapter,
    assessmentDateNew:              defaultState.assessmentDateNew,
    assessmentTimeNew:              defaultState.assessmentTimeNew,
    mustShowRestrictedAccessPopup:  defaultState.mustShowRestrictedAccessPopup,
    assessmentVersion:              defaultState.assessmentVersion
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getSummaryDataNew:                  state => state.summaryDataNew,
    getActiveChapter:                   state => state.activeChapter,
    getAssessmentDate:                  state => state.assessmentDateNew,
    getAssessmentTime:                  state => state.assessmentTimeNew,
    getMustShowRestrictedAccessPopup:   state => state.mustShowRestrictedAccessPopup,
    getAssessmentVersion:               state => state.assessmentVersion

};


// ======================================================================
// Actions
// ======================================================================

const actions = {

    loadAssessmentData ({ commit, dispatch }, requestParamsObj) {
        let promise = new Promise((resolve, reject) => {

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/share', requestParamsObj);
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {

                    let date_time = response.data.assessmentDate;
                    let dateValue = date_time.replace(/ .*/,'');
                    let timeValue = date_time.replace(/.* /,'');

                    commit('setAssessmentDateNew', dateValue);
                    commit('setAssessmentTimeNew', timeValue);

                    commit('setSummaryDataNew', {
                        'assessmentDateNew': response.data.assessmentDate,
                        'assessmentToken': response.data.assessmentToken,
                        'assessmentVersion': response.data.assessmentVersion,
                        'decisionItem1': response.data.decisionItem1,
                        'decisionItem2': response.data.decisionItem2,
                        'target': response.data.target,
                        'interactionCode': response.data.interactionCode,
                        'mainSymptom': response.data.mainSymptom,
                        'relatedSymptomList': response.data.relatedSymptomList,
                    });
                    commit('setAssessmentVersion', response.data.assessmentVersion);

                    resolve(response);
                }
                else {
                    if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 262) {
                        reject("Assessment not found.");
                    }
                    else {
                        reject("Couldn't retrieve assessment data.");
                    }
                }

            });
            axiosRequest.catch((error) => {
                if (error.serverResponse.data.returnCode === 109) {
                    commit("setMustShowRestrictedAccessPopup", true)
                }
            });
        });

        return promise;
    }

};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    // ----------- Summary Data: -----------

    setSummaryDataNew (state, data) {
        state.summaryDataNew = data;
    },

    // ----------------------------------------------------------

    resetStore (state) {
        state.summaryDataNew = defaultState.summaryDataNew;
    },

    setActiveChapter (state, chapterObj) {
        state.activeChapter = chapterObj;
    },
    setAssessmentDateNew(state, data) {
        state.assessmentDateNew = data;
    },
    setAssessmentTimeNew(state, data) {
        state.assessmentTimeNew = data;
    },
    setMustShowRestrictedAccessPopup(state, data) {
        state.mustShowRestrictedAccessPopup = data;
    },
    setAssessmentVersion(state, data) {
        state.assessmentVersion = data;
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/AssessmentShareStore.js